export default __webpack_public_path__ + "static/1680-c7a4f5de39d9e4022602cb1cdf125701.gif";